import { render, staticRenderFns } from "./customer-study.vue?vue&type=template&id=287a57d6&scoped=true"
import script from "./customer-study.vue?vue&type=script&lang=js"
export * from "./customer-study.vue?vue&type=script&lang=js"
import style0 from "./customer-study.vue?vue&type=style&index=0&id=287a57d6&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../../../node_modules/@vue/cli-service/node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "287a57d6",
  null
  
)

export default component.exports